import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../../environments/environment";
import {ClaimDto} from "../../../../auto-generated-server-dtos/adjuster/claim/claim-dto";

@Injectable({
  providedIn: 'root'
})
export class GetClaimService {

  constructor(private httpClient: HttpClient) { }

  public GetClaim(claimId: number): Observable<ClaimDto> {
    return this.httpClient.get<ClaimDto>(`${environment.apiServer}/Adjuster/Claim/GetClaim`, {params: {claimId: claimId}});
  }
}
